import firebase from 'firebase';
// import auth from 'firebase.auth';

const config = {
  apiKey: "AIzaSyB3Y12CpuV-Mv2-FViO7zmFehFv3i0PpIg",
  authDomain: "course-visualization-9278c.firebaseapp.com",
  databaseURL: "https://course-visualization-9278c.firebaseio.com",
  messagingSenderId: "420001638108",
  projectId: "course-visualization-9278c",
  storageBucket: "course-visualization-9278c.appspot.com"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();

export {
  auth,
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js